module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-mdx/gatsby-browser.js'),
      options: {"plugins":[],"gatsbyRemarkPlugins":[{"resolve":"gatsby-remark-images","options":{"maxWidth":1400,"quality":80,"withWebp":true,"linkImagesToOriginal":false}}]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Gatsby Budapest Theme","short_name":"Gatsby Budapest","lang":"en-GB","description":"Modern minimalist Gatsby Theme.","start_url":"/","background_color":"#C8E6C9","theme_color":"#C8E6C9","display":"minimal-ui","icon":"./src/images/favicon.png"},
    },{
      plugin: require('../node_modules/gatsby-plugin-theme-ui/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/@owdlevi/gatsby-theme-budapest/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
